import { render, staticRenderFns } from "./RecursoForm.vue?vue&type=template&id=5a715a58"
import script from "./RecursoForm.vue?vue&type=script&lang=js"
export * from "./RecursoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports